export default __webpack_public_path__ + "static/media/Fences.256.7356bb8e.png";